import React, { Component } from 'react';
import Select from 'react-select';

import { getUIEventTypeNames, getUIReminderValues, getUIRepeatValues } from './event_UI_helpers';
import { getCurrentCaseParticipants } from '../cases/selector';
import { convertDateToTZ } from './timezone_helper';
import { defaultEndDateFromStart } from './event_UI_helpers';

import { OPComponent, Container, I18n, DateUtils, DatePicker, PhoneInput } from '../components';

import EventDateTime from './event_date_time';

import { Image, StyleSheet, Switch, Text, View, InteractionManager } from 'react-native';
import { FONT, FONT_SIZE, COLOR, SELECT_STYLE, THEME } from '../../constants/styles';
import { connect } from 'react-redux';

const styles = StyleSheet.create({
  formField: {
    position: 'relative',
    flexDirection: 'row',
    borderBottomWidth: 1,
    borderTopWidth: 1,
    borderColor: COLOR.accent,
    paddingHorizontal: 25,
    paddingVertical: 15,
    justifyContent: 'flex-start',
    alignContent: 'flex-start',
    alignItems: 'center',
    zIndex: 0,
  },
  text: {
    ...FONT.medium,
    fontSize: FONT_SIZE.regular,
    textAlign: 'center',
  },
  iconButtonWrapper: {
    flex: 0.2,
  },
  iconButtonIcon: {
    width: 20,
    height: 20,
    marginRight: 20,
  },
  iconButtonLabelText: {
    ...FONT.regular,
    fontSize: FONT_SIZE.large,
    marginLeft: 20,
  },
  selectField: {
    flexDirection: 'row',
    flex: 0.8,
  },
  formLabel: {
    flex: 0.2,
  },
  settingText: {
    flex: 0.6,
    ...FONT.regular,
    fontSize: FONT_SIZE.large,
    color: COLOR.textLight,
    marginRight: 5,
  },
  dateFields: {
    marginLeft: 10,
    flexDirection: 'column',
  },
  inputContainer: {
    margin: 0,
    padding: 0,
    borderRadius: 5,
    borderTopWidth: 0,
    borderBottomWidth: 0,
    // height: 55,
  },
  input: {
    marginLeft: 1,
    marginRight: 1,
    marginTop: 1,
    marginBottom: 1,
    paddingLeft: 10,
    paddingRight: 10,
    paddingTop: 5,
    // marginRight: 0,
    height: 'auto',
    backgroundColor: COLOR.contrast,
    color: COLOR.textLight,
    fontSize: FONT_SIZE.regular,
  },
});

class EventSettings extends OPComponent {
  constructor(props) {
    super(props);

    this.state = {
      repeatShouldEnd: false,
      repeatEnd: new Date(),
      allDay: false,
    };

    // we should populate a default start date of today
    if (!props.startDate) {
      // set the default timezone
      const timeZone = props.timeZone || 'America/Los_Angeles';
      // set the selected date as the seed start date if we got one
      const seedDate = props.selectedDate || new Date();
      const startDate = convertDateToTZ(seedDate, timeZone);
      const endDate = defaultEndDateFromStart(startDate);
      this.props.onStartDate(startDate);
      this.props.onEndDate(endDate);
      this.props.onTimeZone(timeZone);

      this.state.intialStartDate = startDate;
      this.state.initialEndDate = endDate;
    }
  }

  formattedDateString() {
    const { startDate, timeZone } = this.props;
    if (!startDate) return I18n.t('calendar.dateAndTime');
    return DateUtils.formatDateString(startDate, timeZone);
  }
  formattedTimeString() {
    const { startDate, endDate, allDay, selectedDate, timeZone } = this.props;
    if (!startDate) return '';

    if (allDay) return I18n.t('calendar.allDay');

    let startTimeStr = DateUtils.formatTimeString(startDate, timeZone);
    let endTimeStr;
    if (
      endDate &&
      DateUtils.formatDateString(startDate, timeZone) ==
        DateUtils.formatDateString(endDate, timeZone)
    ) {
      endTimeStr = DateUtils.formatTimeString(endDate, timeZone);
    }
    let timeStr;
    if (endTimeStr) {
      timeStr = `${startTimeStr} - ${endTimeStr}`;
    } else {
      timeStr = `${startTimeStr}`;
    }

    timeStr += `\n${timeZone}`;
    return timeStr;
  }

  setStartDate = (startDate) => {
    this.props.onStartDate(startDate);
  };
  setEndDate = (endDate) => {
    this.props.onEndDate(endDate);
  };
  setAllDay = (allDay) => {
    this.props.onAllDay(allDay);
  };
  setTimeZone = (timeZone) => {
    this.props.onTimeZone(timeZone);
  };

  render() {
    const { eventTypeName, allowEditingType, phone, participants, endDate, repeat } = this.props;

    const participantOptions = [
      {
        id: 0,
        label: I18n.capitalizeFirst('calendar.noOne'),
      },
      ...participants.map((p) => ({
        id: p.profile.userId,
        label: p.profile.friendlyName,
      })),
    ];
    // <IconButton
    //   label={I18n.t('calendar.eventType')}
    //   value={I18n.t(`calendar.eventTypes.${eventTypeName}`, {
    //     defaults: [{ message: eventTypeName }],
    //   })}
    //   imageSource={require('../../../resources/icon-event-type.png')}
    //   onPress={this.openEventTypeSetting}
    //   disabled={!allowEditingType}
    // />
    return (
      <Container>
        <View
          style={[
            styles.formField,
            {
              zIndex: this.state.openMenu === 'eventType' ? 999 : 0,
            },
          ]}
        >
          <Image
            style={styles.iconButtonIcon}
            source={require('../../../resources/icon-event-type.png')}
          />
          <Text style={styles.formLabel}>{I18n.t('calendar.eventType')}</Text>

          <View style={styles.selectField}>
            {/* use allowEditingType to control editing and placeholder value */}
            <Select
              styles={SELECT_STYLE}
              options={getUIEventTypeNames()}
              isDisabled={!allowEditingType}
              onMenuOpen={() => this.setState({ openMenu: 'eventType' })}
              onMenuClose={() => this.setState({ openMenu: false })}
              onChange={({ label }) => this.props.onEventTypeName(label)}
              placeholder={allowEditingType ? I18n.t('calendar.eventType') : eventTypeName}
            />
          </View>
        </View>

        <View
          style={[
            styles.formField,
            {
              zIndex: this.state.openMenu === 'phone' ? 999 : 0,
            },
          ]}
        >
          <Image
            style={styles.iconButtonIcon}
            source={require('../../../resources/icon-phone.png')}
          />
          <Text style={styles.formLabel}>{I18n.t('phone')}</Text>
          <View style={[styles.selectField, { flexDirection: 'column' }]}>
            <PhoneInput
              value={phone}
              required={false}
              invalidText={I18n.t('form.phoneInvalid')}
              label={I18n.ac('phone')}
              autoCapitalize="none"
              keyboardType="phone-pad"
              returnKeyType="done"
              onChangeText={this.props.onPhone}
              flexibleHeight={true}
              onFocus={() => this.setState({ openMenu: 'phone' })}
              onBlur={() => this.setState({ openMenu: false })}
            />
          </View>
        </View>

        <View style={[styles.formField, { zIndex: 0 }]}>
          <Image
            style={styles.iconButtonIcon}
            source={require('../../../resources/icon-time.png')}
          />
          <Text style={styles.formLabel}>{this.formattedDateString()}</Text>
          <View style={styles.selectField}>
            <EventDateTime
              timeZone={this.props.timeZone}
              startDate={this.props.startDate || this.state.intialStartDate}
              endDate={this.props.endDate || this.state.initialEndDate}
              allDay={this.props.allDay}
              onStartDate={this.setStartDate}
              onEndDate={this.setEndDate}
              onAllDay={this.setAllDay}
              onTimeZone={this.setTimeZone}
              componentId={this.props.componentId}
            />
          </View>
        </View>

        <View
          style={[
            styles.formField,
            {
              zIndex: this.state.openMenu === 'reminder' ? 999 : 0,
            },
          ]}
        >
          <Image
            style={styles.iconButtonIcon}
            source={require('../../../resources/icon-reminder.png')}
          />
          <Text style={styles.formLabel}>{I18n.t('calendar.reminder')}</Text>
          <View
            // onPress={this.openDateTimeSetting}
            style={styles.selectField}
          >
            <Select
              styles={SELECT_STYLE}
              onMenuOpen={() => this.setState({ openMenu: 'reminder' })}
              onMenuClose={() => this.setState({ openMenu: false })}
              options={getUIReminderValues()}
              onChange={(val) => {
                this.props.onReminder(val.id);
              }}
              placeholder={I18n.t('calendar.reminder')}
            />
          </View>
        </View>

        <View
          style={[
            styles.formField,
            {
              zIndex: this.state.openMenu === 'repeat' ? 999 : 0,
            },
          ]}
        >
          <Image
            style={styles.iconButtonIcon}
            source={require('../../../resources/icon-repeat.png')}
          />
          <Text style={styles.formLabel}>{I18n.t('calendar.repeat')}</Text>
          <View style={[styles.selectField, { flex: 0.3 }]}>
            <Select
              styles={SELECT_STYLE}
              onMenuOpen={() => this.setState({ openMenu: 'repeat' })}
              onMenuClose={() => this.setState({ openMenu: false })}
              options={getUIRepeatValues()}
              onChange={({ id }) => {
                this.props.onRepeat({ ...repeat, repeat: id });
              }}
              // value={getUIRepeatText(repeat)}
              placeholder={I18n.t('calendar.repeat')}
            />
          </View>
          <View style={[styles.selectField, { flex: 0.15, paddingLeft: 10 }]}>
            {/* Only show ends toggle if we're repeating */}
            {repeat?.repeat >= 0 && (
              <View>
                <Text style={styles.settingText}>{I18n.t('calendar.endsOn')}</Text>

                <Switch
                  value={this.state.repeatShouldEnd}
                  onValueChange={() => {
                    this.setState((prevState) => {
                      const repeatShouldEnd = !prevState.repeatShouldEnd;
                      // update the parent with the repeating state
                      this.props.onRepeat({
                        ...repeat,
                        endDate: repeatShouldEnd ? new Date() : null,
                      });
                      return {
                        repeatShouldEnd,
                      };
                    });
                  }}
                />
              </View>
            )}
          </View>
          <View
            style={[
              styles.selectField,
              {
                flex: 0.3,
                zIndex: this.state.openMenu === 'repeat' ? 999 : 0,
              },
            ]}
          >
            {/* Only show the repeat end if we're repeating and it ends */}
            {repeat?.repeat >= 0 && this.state.repeatShouldEnd && (
              <View>
                <DatePicker
                  onFocus={() => this.setState({ openMenu: 'repeat' })}
                  onBlur={() => this.setState({ openMenu: false })}
                  selectedDate={this.state.repeatEnd}
                  minDate={endDate}
                  disableClock
                  onDate={(date) => {
                    this.setState({ repeatEnd: date });
                    // pass this onto prop repeat too
                    this.props.onRepeat({
                      ...repeat,
                      endDate: date,
                    });
                  }}
                />
              </View>
            )}
          </View>
        </View>

        <View
          style={[
            styles.formField,
            {
              zIndex: this.state.openMenu === 'assignedTo' ? 999 : 0,
            },
          ]}
        >
          <Image
            style={styles.iconButtonIcon}
            source={require('../../../resources/icon-flag.png')}
          />
          <Text style={styles.formLabel}>{I18n.capitalizeEach('calendar.assignedTo')}</Text>
          <View
            // onPress={this.openAssignment}
            style={styles.selectField}
          >
            <Select
              styles={SELECT_STYLE}
              onMenuOpen={() => this.setState({ openMenu: 'assignedTo' })}
              onMenuClose={() => this.setState({ openMenu: false })}
              options={participantOptions}
              onChange={({ id }) => this.props.onAssignee(id)}
              placeholder={I18n.capitalizeEach('calendar.assignedTo')}
            />
          </View>
        </View>
      </Container>
    );
  }
}

function mapStateToProps(state, ownProps) {
  return {
    participants: getCurrentCaseParticipants(state),
    followers: state.entities.followers,
  };
}
export default connect(mapStateToProps)(EventSettings);
